const ctx = new (window.AudioContext ||
  (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();

export function resumeAudio(): void { ctx.resume(); }

function tone(freq: number, dur: number, vol = 0.15, type: OscillatorType = 'sine'): void {
  if (ctx.state === 'suspended') return;
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(vol, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + dur);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + dur);
  } catch { /* ignore */ }
}

export function playPick(): void {
  tone(520, 0.08, 0.12);
}

export function playLand(): void {
  tone(380, 0.10, 0.10);
}

export function playMatch(): void {
  tone(523, 0.12, 0.18);
  setTimeout(() => tone(659, 0.12, 0.18), 110);
  setTimeout(() => tone(784, 0.18, 0.18), 220);
}

export function playWin(): void {
  [523, 659, 784, 1047].forEach((f, i) => {
    setTimeout(() => tone(f, 0.4, 0.18), i * 120);
  });
}

export function playLose(): void {
  tone(330, 0.12, 0.15);
  setTimeout(() => tone(277, 0.25, 0.12), 120);
}

export function playHint(): void {
  tone(660, 0.10, 0.10);
}
